const STYLES = {
  confirmed: "border-confirmed/30 bg-confirmed/10 text-confirmed",
  cancelled: "border-cancelled/30 bg-cancelled/10 text-cancelled",
  paid: "border-gold/40 bg-gold/15 text-gold",
  verified: "border-gold/40 bg-gold text-ink",
  pending: "border-line bg-elevated text-mist",
  not_received: "border-cancelled/30 bg-cancelled/10 text-cancelled",
  quote_pending: "border-gold/30 bg-gold/10 text-gold",
};
const LABELS = {
  confirmed: "Confirmed",
  cancelled: "Cancelled",
  paid: "Paid",
  verified: "Verified",
  pending: "Payment pending",
  not_received: "Payment not received",
  quote_pending: "Quote pending",
};

const Badge = ({ kind, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.16em] ${STYLES[kind]}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {LABELS[kind]}
  </span>
);

function extraBadge(b) {
  if (b.status === "cancelled") return null;
  if (b.quote_status === "pending") return "quote_pending";
  if (b.payment_status === "paid" && b.payment_verification === "verified") return "verified";
  if (b.payment_status === "pending") return "pending";
  if (b.payment_status === "unpaid" && b.payment_verification === "not_received") return "not_received";
  return null;
}

export function StatusBadges({ booking, testId = "booking" }) {
  const main = booking.status === "cancelled" ? "cancelled" : booking.payment_status === "paid" ? "paid" : "confirmed";
  const extra = extraBadge(booking);
  return (
    <div className="flex flex-wrap items-center justify-end gap-1.5">
      <Badge kind={main} testId={`${testId}-status-badge`} />
      {extra && <Badge kind={extra} testId={`${testId}-payment-${extra.replace("_", "-")}-badge`} />}
    </div>
  );
}
